export default "__VITE_ASSET__dfef1878__"